export const GET_VAPID_PUBLIC_KEY_REQUEST = 'GET_VAPID_PUBLIC_KEY_REQUEST';
export const SUBSCRIBE_PUSH_REQUEST = 'SUBSCRIBE_PUSH_REQUEST';
export const UNSUBSCRIBE_PUSH_REQUEST = 'UNSUBSCRIBE_PUSH_REQUEST';

export const getVapidPublicKey = (callback) => ({
    type: GET_VAPID_PUBLIC_KEY_REQUEST,
    payload: { callback },
});

export const subscribePush = (subscriptionData, callback) => ({
    type: SUBSCRIBE_PUSH_REQUEST,
    payload: { subscriptionData, callback },
});

export const unsubscribePush = (endpoint, callback) => ({
    type: UNSUBSCRIBE_PUSH_REQUEST,
    payload: { endpoint, callback },
});

export const GET_PUSH_STATUS_REQUEST = 'GET_PUSH_STATUS_REQUEST';

export const getPushStatus = (callback) => ({
    type: GET_PUSH_STATUS_REQUEST,
    payload: { callback },
});
